import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {openWorkOrderVolte} from '../../../utilities/openWorkOrder';
import ProviderManager from '../../../provider/providerManager';
import {stageEnums} from './Assets/VolteCheckVariables';

export const checkForVolteService = createAsyncThunk('volteCheckSlice/checkForVolteService', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('checkForVolteService', [data.subscriber]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    console.log('volte service error ', error);
    return {serverError: true};
  }
});

export const createWorkOrderAuth = createAsyncThunk('volteCheckSlice/createWorkOrderAuth', async (data, thunkAPI) => {
  try {
    let request = {
      orderType: 'VOLTE',
      subscriber: data.selectedSubscriber,
      firstName: data.firstName,
      lastName: data.lastName,
      enteredSub: data.enteredSub,
      identityNumber: data.id,
      banList: [],
      psidList: [],
      movingApartment: null,
      saleJet: null,
    };
    const result = await ProviderManager.getProviderData('createWorkOrder', request);
    return {data: result?.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});
export const openWorkOrder = createAsyncThunk('volteCheckSlice/openWorkOrder', async (data, thunkAPI) => {
  try {
    const request = {
      fullName: data.fullName,
      contactNumber: data.contactNumber,
      isDynamica: data.isDynamica,
    };
    const result = await openWorkOrderVolte(request);
    return {data: {isSuccess: result}, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

export const checkImeiForVolte = createAsyncThunk('volteCheckSlice/checkImeiForVolte', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('checkImeiForVolte', [data.imei]);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

const initialState = {
  stageStep: stageEnums.start,
  isLoading: false,
  allCellularAccounts: [],
  deviceData: {},
  sentCallback: false,
  cellSubscribers: [],
};

const volteCheckSlice = createSlice({
  name: 'volteCheckSlice',
  initialState: initialState,
  reducers: {
    setStage: (state, action) => {
      state.stageStep = action.payload;
    },
    resetState: () => initialState,
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSubs: (state, action) => {
      state.cellSubscribers = action.payload;
    },
  },
  extraReducers: {
    [createWorkOrderAuth.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [createWorkOrderAuth.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.stageStep = stageEnums.error;
        return state;
      }
      state.sentCallback = action.payload.data.isSuccess;
      return state;
    },
    [createWorkOrderAuth.rejected]: (state, action) => {
      state.isLoading = false;
      state.stageStep = stageEnums.error;
      return state;
    },
    [openWorkOrder.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [openWorkOrder.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.stageStep = stageEnums.error;
        return state;
      }
      state.sentCallback = action.payload.data.isSuccess;
      return state;
    },
    [openWorkOrder.rejected]: (state, action) => {
      state.isLoading = false;
      state.stageStep = stageEnums.error;
      return state;
    },
    [checkForVolteService.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [checkForVolteService.fulfilled]: (state, action) => {
      if (!state.isLoading) {
        return state;
      }
      state.isLoading = false;
      if (action.payload.serverError) {
        state.stageStep = stageEnums.error;
        return state;
      }
      const {validationSuccess, isSupported, installationNeeded, activationNeeded} = action.payload.data;
      if (validationSuccess) {
        if (isSupported) {
          if (activationNeeded || installationNeeded) {
            state.stageStep = stageEnums.inactive;
          } else {
            state.stageStep = stageEnums.active;
          }
        } else {
          state.stageStep = stageEnums.notSupported;
        }
      } else {
        state.stageStep = stageEnums.error;
      }
      return state;
    },
    [checkForVolteService.rejected]: (state, action) => {
      state.isLoading = false;
      state.stageStep = stageEnums.error;
      return state;
    },
    [checkImeiForVolte.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [checkImeiForVolte.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.serverError) {
        state.stageStep = stageEnums.error;
        return state;
      }
      const {validationSuccess, isSupported} = action.payload.data;
      if (validationSuccess) {
        if (isSupported) {
          state.stageStep = stageEnums.active;
        } else {
          state.stageStep = stageEnums.notSupported;
        }
      } else {
        state.stageStep = stageEnums.error;
      }

      return state;
    },
    [checkImeiForVolte.rejected]: (state, action) => {
      state.isLoading = false;
      state.stageStep = stageEnums.error;
      return state;
    },
  },
});

export const {setStage, resetState, setLoading, setSubs} = volteCheckSlice.actions;

export default volteCheckSlice.reducer;
